import auth from './auth'
import companySuppliers from './companySuppliers'
import companySupplierQuestionnaires from './companySupplierQuestionnaires'
import companySupplierQuestionnaireUsers from './companySupplierQuestionnaireUsers'
import questionnaireAlternativeAnswers from './questionnaireAlternativeAnswers'
import quizQuestionTemplates from './quizQuestionTemplates'
import twoFactorAuthentication from './twoFactorAuthentication'
import users from './users'
import whiteLabel from './whiteLabel'

export default {
  auth,
  companySuppliers,
  companySupplierQuestionnaires,
  companySupplierQuestionnaireUsers,
  questionnaireAlternativeAnswers,
  quizQuestionTemplates,
  twoFactorAuthentication,
  users,
  whiteLabel,
}
